import script from "./HistoricalMaterialForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoricalMaterialForm.vue?vue&type=script&setup=true&lang=js"

import "./HistoricalMaterialForm.vue?vue&type=style&index=0&id=11d35862&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11d35862"]])

export default __exports__